import React, {Component, createRef} from 'react';
import $ from "jquery"

import Style from './FJDropDownMenu.module.less'
import FJUtil from "../../../../util/FJUtil";
import FJArrowIcon from '../../../../icon/arrow.svg';
import InlineSVG from "react-inlinesvg";
import classNames from 'classnames';
import FJCustomScroll from "../../../../common/component/FJCustomScroll";

class FJDropDownMenu extends Component {
    constructor(props) {
        super(props);
        this._dropBtn = createRef();
        this._dropMenu = createRef();
    }
    componentDidMount() {
    }

    _bindEventBool = false;

    /**
     * @description 渲染页面
     * @param list
     * @private
     */
    _getComps = (list) => {
        let items = [];
        list.forEach((item, index) => {
            items.push(
              <li className={Style.menu_item + ' u-ellipsis'} key={index} title={item}
                  onClick={() => {this.props.onClick(index);this._hide();}}>{item}</li>
            );
        });
        return items;
    };

    /**
     * @description 点击下拉按钮
     * @private
     */
    _dropBtnClick = () => {
        if (this.props.onShow) {
            this.props.onShow();
        }

        if ($(this._dropMenu.current).css('display') === "none") {
            this._show();
        } else {
            this._hide();
        }
    };

    /**
     * @description 显示下拉菜单
     * @private
     */
    _show = () => {
        $(this._dropMenu.current).show();
        this._bindEvent();
    };

    /**
     * @description 隐藏下拉菜单
     * @private
     */
    _hide = () => {
        $(this._dropMenu.current).hide();
        if (this.props.onHide) {
            this.props.onHide();
        }
        this._unBindEvent();
    };

    /**
     * @description 绑定事件
     * @private
     */
    _bindEvent = () => {
        if (!this._bindEventBool) {
            $(document.body).bind("keydown", this._keyDown);
            $(document.body).bind("mousedown", this._mouseDown);
            this._bindEventBool = true;
        }
    };

    /**
     * @description 取消绑定 事件
     * @private
     */
    _unBindEvent = () => {
        if (this._bindEventBool) {
            $(document.body).unbind("keydown", this._keyDown);
            $(document.body).unbind("mousedown", this._mouseDown);
            this._bindEventBool = false;
        }
    };

    /**
     * @description 键盘事件触发
     * @param e
     * @private
     */
    _keyDown = (e) => {
        // Esc 按下
        if (e.keyCode === 27) {
            this._hide();
        }
    };

    /**
     * @description 鼠标事件触发
     * @private
     */
    _mouseDown = (e) => {
        if (!FJUtil.isPanelArea(e, this._dropMenu.current) && !FJUtil.isPanelArea(e, this._dropBtn.current)) {
            this._hide();
        }
    };

    render() {
        let {list, showIndex, className, style, showNumber} = this.props;
        let height = list.length * 36 + 20;
        if (list.length > showNumber) {
            height = showNumber * 36 + 20;
        }
        let cn = classNames(Style.drop_box, className);
        return (
                <div className={cn} style={style}>
                    <div className={Style.drop_btn} ref={this._dropBtn} onClick={this._dropBtnClick}>
                        <p className={Style.desc + ' u-ellipsis'} title={list[showIndex]}>{list[showIndex]}</p>
                        <InlineSVG src={FJArrowIcon} element='div' />
                    </div>
                    <div className={Style.drop_menu} ref={this._dropMenu} style={{height: height}}>
                        <FJCustomScroll >
                            <ul>
                                {this._getComps(list)}
                            </ul>
                        </FJCustomScroll>
                    </div>
                </div>
        );
    }
}

export default FJDropDownMenu;
